import './src/styles/global.css'
import '@fortawesome/fontawesome-svg-core/styles.css'

import { config } from '@fortawesome/fontawesome-svg-core'
import { register } from 'swiper/element/bundle'

config.autoAddCss = false

// register Swiper custom elements
register()